import { getCompanyUsage, getLinearUsers, getProductFeatures } from '@/redux/actions/settingsActions';
import { getOrgState } from '@/redux/actions/userActions';
import { getCompanyIntegrationsProjects, getIntegrators } from '@/redux/actions/gravityActions';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const OrgStateHandler = () => {
  const companyId = useSelector(selectors.companyId);
  const isAdmin = useSelector(selectors.admin);

  useEffect(() => {
    if (companyId) {
      getOrgState();
      getCompanyUsage();
      getCompanyIntegrationsProjects();
      getProductFeatures();

      if (isAdmin) {
        getLinearUsers({});
        getIntegrators({});
      }
    }
  }, [companyId, isAdmin]);

  return null;
};

export default OrgStateHandler;
